import React from "react";
import { useInView } from "react-intersection-observer";
import app_store from "../images/app-store.png";
import google_play from "../images/google-play.png";
import { ReactComponent as LinkedInIcon } from "../images/linkedin.svg";
import styles from "./Cta.module.css";
import { imageObject } from "../constants/image";

const DEFAULT_SOCIALS = [
  {
    key: "youtube",
    href: "https://www.youtube.com/@TargeTube",
    src: imageObject.youtube,
    alt: "YouTube",
  },
  {
    key: "x",
    href: "https://x.com/TargeTube",
    src: imageObject.twitter,
    alt: "X",
  },
  {
    key: "tiktok",
    href: "https://www.tiktok.com/@targetube",
    src: imageObject.tikTok,
    alt: "TikTok",
  },
  {
    key: "facebook",
    href: "https://www.facebook.com/TargeTube/",
    src: imageObject.facebook,
    alt: "Facebook",
  },
  {
    key: "linkedin",
    href: "https://www.linkedin.com/in/targetubee/",
    linkedInSvg: true,
    alt: "LinkedIn",
  },
  {
    key: "instagram",
    href: "https://www.instagram.com/targetube/",
    src: imageObject.instagram,
    alt: "Instagram",
  },
  {
    key: "telegram",
    href: "https://t.me/TargeTube",
    src: imageObject.telegram,
    alt: "Telegram",
  },
  {
    key: "whatsapp",
    href: "https://chat.whatsapp.com/IewrOxSAHNu3cq8mD1T92B",
    whatsappSvg: true,
    alt: "WhatsApp",
  },
];

function resolveSocials(socialLinks) {
  // No admin config yet → show defaults.
  if (!socialLinks || typeof socialLinks !== "object") {
    return DEFAULT_SOCIALS;
  }

  // Config exists → hide icon when URL field is empty.
  return DEFAULT_SOCIALS.map((item) => {
    const href = (socialLinks[item.key] ?? "").toString().trim();
    return { ...item, href };
  }).filter((item) => item.href.length > 0);
}

export default function Cta({ title, description, socialLinks }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  const socials = resolveSocials(socialLinks);

  return (
    <div
      className={`${styles.ctamain} ${inView ? styles.inView : ""}`}
      ref={ref}
    >
      <div className="container-fluid px-0">
        <div className="row justify-content-center g-0 mx-0">
          <div className="col-12">
            <div className="row justify-content-center g-0 mx-0">
              <div className="col-12 px-3 px-md-4 px-lg-5 text-center">
                <div className={styles.ctacontent}>
                  <span className={styles.ctaTitle}>{title}</span>
                  <div
                    className={styles.ctaDescription}
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                  />

                  <div className={styles.app_btn}>
                    <a href="https://apps.apple.com/us/app/targetube/id6468591285">
                      <img src={app_store} alt="" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.targetube.app">
                      <img src={google_play} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.socialMediaIcons} dir="ltr">
        {socials.map((s) => (
          <a
            key={s.alt}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            title={s.alt}
            aria-label={s.alt}
            className={s.whatsappSvg ? styles.whatsappLink : undefined}
          >
            {s.linkedInSvg ? (
              <LinkedInIcon
                width={50}
                height={50}
                className={styles.socialIcon}
              />
            ) : s.whatsappSvg ? (
              <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
                <path
                  fill="#ffffff"
                  d="M12.04 2C6.58 2 2.15 6.43 2.15 11.89c0 1.75.46 3.45 1.32 4.95L2 22l5.3-1.39c1.45.79 3.08 1.21 4.74 1.21h.01c5.46 0 9.89-4.43 9.89-9.89C21.94 6.43 17.5 2 12.04 2zm5.75 14.13c-.24.67-1.4 1.24-1.94 1.32-.5.07-1.13.1-1.82-.11-.42-.13-.95-.31-1.64-.61-2.89-1.25-4.77-4.16-4.92-4.35-.14-.19-1.18-1.57-1.18-3 0-1.42.74-2.12 1.01-2.41.26-.29.58-.36.77-.36h.55c.18 0 .42-.07.65.5.24.58.82 2 .89 2.15.07.14.12.31.02.5-.1.19-.14.31-.28.48-.14.16-.3.37-.42.49-.14.14-.28.29-.12.56.16.28.72 1.19 1.55 1.93 1.07.95 1.97 1.25 2.25 1.39.28.14.44.12.61-.07.16-.19.7-.81.89-1.09.19-.28.37-.23.63-.14.26.1 1.64.77 1.92.91.28.14.46.21.53.33.07.12.07.7-.17 1.37z"
                />
              </svg>
            ) : (
              <img src={s.src} alt={s.alt} className={styles.socialIcon} />
            )}
          </a>
        ))}
      </div>
    </div>
  );
}
